import { STATUS_UNAUTHORIZED } from '@ws/shared/utils';

// Единая политика классификации исходов sync-вызова (I3 §2.6). Чистая функция без
// побочных эффектов; реакции (тост/статус/retry) — у вызывающих, per-context.
// Потребители: EventTrain (apply/delta), supervisor + health-мост (MR-3).
export type TSyncFailureClass =
  | 'cancelled'
  | 'transport' // сеть/CORS/abort — статуса нет
  | 'retryable-http' // 5xx / 408 / 429 — повтор осмыслен
  | 'auth-required' // 401
  | 'terminal-http' // прочие 4xx (вкл. 400 — но apply трактует 400 отдельно, до вызова)
  | 'invalid-response' // 2xx, но тело невалидно
  | 'unknown'; // 2xx/3xx — не ошибка

// Транзиентные HTTP-статусы, при которых повтор осмыслен (совпадает с таксономией И2).
const RETRYABLE_HTTP = new Set([408, 429]);

export type TSyncFailureInput = {
  // kind из TSyncCallResult (пробы) — опционально; иначе классифицируем по статусу.
  kind?: 'ok' | 'http' | 'transport' | 'invalid-response' | 'cancelled';
  status?: number;
};

export function classifySyncFailure(input: TSyncFailureInput): TSyncFailureClass {
  if (input.kind === 'cancelled') {
    return 'cancelled';
  }
  if (input.kind === 'transport') {
    return 'transport';
  }
  if (input.kind === 'invalid-response') {
    return 'invalid-response';
  }

  const { status } = input;

  // Нет статуса (fetch reject) — транспорт.
  if (typeof status === 'undefined') {
    return 'transport';
  }

  if (status === STATUS_UNAUTHORIZED) {
    return 'auth-required';
  }

  if (status >= 500 || RETRYABLE_HTTP.has(status)) {
    return 'retryable-http';
  }

  if (status >= 400) {
    return 'terminal-http';
  }

  // 2xx/3xx — не является ошибкой.
  return 'unknown';
}

// Повтор осмыслен только для транзиента (сеть или retryable-HTTP).
export function isRetryableFailure(cls: TSyncFailureClass): boolean {
  return cls === 'transport' || cls === 'retryable-http';
}
